export const setToken = (staKey, val) => {
  localStorage.setItem(staKey, val)
}

export const getToken = (getKey) => {
  return localStorage.getItem(getKey)
}

export const removeToken = (getKey) => {
  localStorage.removeItem(getKey)
}
